import { QueryClient, useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { acknowledgeAlarm, acknowledgeAllAlarms, listAlarms } from '../api/endpoints/alarms';
import { LIVE_ALARM_REFETCH_MS } from './useAlarmFeed';

const ALARMS_KEY = ['alarms'];

export function useAlarms() {
  return useQuery({ queryKey: ALARMS_KEY, queryFn: listAlarms, refetchInterval: LIVE_ALARM_REFETCH_MS });
}

// Acknowledging changes the dashboard feeds and the plant scene's per-unit status too.
function invalidateAlarmViews(queryClient: QueryClient) {
  for (const key of ['alarms', 'alarm-feed', 'plant-scene']) {
    void queryClient.invalidateQueries({ queryKey: [key] });
  }
}

export function useAcknowledgeAlarm() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, acknowledged }: { id: string; acknowledged: boolean }) => acknowledgeAlarm(id, acknowledged),
    onSuccess: () => invalidateAlarmViews(queryClient),
  });
}

export function useAcknowledgeAllAlarms() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: acknowledgeAllAlarms,
    onSuccess: () => invalidateAlarmViews(queryClient),
  });
}
